import { View, Text } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import {
  RDateCity,
  RHeader,
  RPage,
  RViewer,
} from '../../../components/PdfRender';
import * as S from './styles';
import { IHealthCertificate } from '../../interfaces';
import { ICompany } from '../../interfaces/company.interface';
import { formatDate } from '../../utils/format-date';
import { useCompany } from '../../../hooks/company';
import { RSignature } from '../../../components/PdfRender/RSignature';
import { useAuth } from '../../../hooks/auth';

interface IHealthCertificateReportProps {
  report: IHealthCertificate | null;
  signature?: string | null;
  validationCode?: string | null;
  companyOverride?: ICompany | null;
  clinicOverride?: string | null;
}

export const HealthCertificateReport: React.FC<
  IHealthCertificateReportProps
> = ({
  report,
  signature,
  validationCode,
  companyOverride,
  clinicOverride,
}) => {
  const { company } = useCompany();
  const { clinic } = useAuth();
  const reportCompany = companyOverride ?? company;
  const reportClinic =
    clinicOverride ||
    clinic ||
    sessionStorage.getItem('@Sigeclin:patientTenant') ||
    '';
  let renderText: string | null = null;

  if (report) {
    const { client_name, cpf, quantity_days, date, start_time, end_time, cid } =
      report;
    renderText = `${report.text_description}`
      .replace('{nome}', client_name?.toUpperCase() ?? '')
      .replace('{cpf}', cpf ?? '')
      .replace('{qtdDias}', quantity_days ?? '')
      .replace('{data}', formatDate(date) ?? '')
      .replace('{horaInicial}', start_time.slice(0, -3) ?? '')
      .replace('{horaFinal}', end_time.slice(0, -3) ?? '')
      .replace('{cid}', cid ?? '');
  }

  const renderCid = () => {
    if (report?.cid) {
      return (
        <View style={S.styles.containerCid}>
          <Text style={S.styles.cidText}>CID: {report?.cid}</Text>
        </View>
      );
    }
  };

  return (
    <RViewer>
      <RPage>
        <View style={S.styles.container}>
          <RHeader company={reportCompany} />
          <View style={S.styles.containerCode}>
            <Text style={S.styles.codeText}>Nº {report?.code}</Text>
          </View>
          <View style={S.styles.containerTitleDescription}>
            <View style={S.styles.containerTitle}>
              <Text style={S.styles.titleText}>
                {report?.title_health_certificate}
              </Text>
            </View>
            <View style={S.styles.containerDescription}>
              <Html style={S.styles.descriptionText}>{`${renderText}`}</Html>
            </View>
          </View>
          {renderCid()}
          <RDateCity company={reportCompany} issueDate={report?.created_at} />
          <RSignature
            professional_name={report?.professional_name}
            terminology_description={report?.terminology_description}
            terminology_code={report?.terminology_code}
            rqe={report?.rqe}
            signature={signature}
            signed_at={report?.signed_at}
            validation_code={
              validationCode || report?.signature_validation_code
            }
            clinic={reportClinic}
          />
        </View>
      </RPage>
    </RViewer>
  );
};
